(function () {
    'use strict';
    EO_IntakeDataViewerController.$inject = ['$scope', '$attrs', '$element', 'FileUtil', 'OrderBagCustom', 'CompanyCustomerCustom', 'ENV'];

    function EO_IntakeDataViewerController($scope, $attrs, $element, FileUtil, OrderBagCustom, CompanyCustomerCustom, ENV) {
//
        var $ctrl = this;
        $ctrl.isDataLoaded = false;
        $ctrl.downloadFile = downloadFile;
        $ctrl.isEditMode = false;
        $ctrl.save = save;
        $ctrl.cancelEditing = cancelEditing;
        $ctrl.gotoEditMode = gotoEditMode;
        $ctrl.tempIntakeData = null;


        function save() {

            if ($ctrl.intakeData.intakeParentType != "COMPANY_CUSTOMER") {
                OrderBagCustom.updateIntakeFormData().save($ctrl.intakeData, function () {
                    $ctrl.isEditMode = false;

                })
            }
            if ($ctrl.intakeData.intakeParentType == "COMPANY_CUSTOMER") {
                CompanyCustomerCustom.updateCustomerIntakeFormData().save($ctrl.intakeData, function () {
                    $ctrl.isEditMode = false;

                })
            }


        }

        function gotoEditMode() {
            $ctrl.tempIntakeData = JSON.parse(JSON.stringify($ctrl.intakeData));
            $ctrl.isEditMode = true;
        }

        function cancelEditing() {
            $ctrl.intakeData = $ctrl.tempIntakeData;
            $ctrl.isEditMode = false;
        }

        function downloadFile(field) {

            var filename = field.value.replace('file:uploadroot/', '');
            FileUtil.downloadUploadedFile(filename);
        }

        $scope.$watch('$ctrl.intakeData', function (intakeData) {
            if (intakeData) {
                $ctrl.isDataLoaded = true;
                angular.forEach(intakeData.fields, function (field) {
                    if (field.value) {
                        if (field.value.startsWith('file:uploadroot')) {
                            field.isFile = true;
                            var filename = field.value.replace('file:uploadroot/', '');
                            field.href = ENV.API_BASE_URL + 'api/client/downloadfile?fileName=' + filename;
                        }

                    }
                });

            }


        });

    }


    var EO_IntakeDataViewer = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/intake-data/eyeson.intake-data-viewer.template.html',
        controller: EO_IntakeDataViewerController,
        bindings: {
            intakeData: '<'
        }

    };

    angular
        .module('tikonApp')
        .component('eoIntakeDataViewer', EO_IntakeDataViewer)

})();
